const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/services/clientSetupManager.ts';
import _ from 'lodash';
import { ContextFile, ContextFileStore, getRelevantContextData, storeContextFile } from './mainConfig';
import {
    ClientSetup,
    ClientSetupConfig,
    ClientSetupConfigElement,
} from '@cistec/common_web/services/clientSetupManager.defs';

declare let require: any;

const mergeClientSetupFile = (config: ClientSetupConfig, setupData: any, setupFile: any) => {
    _.forEach(setupFile, (def: any, key: string) => {
        if (config[key]?.type === 'merge') {
            if (!setupData[key]) {
                setupData[key] = def;
            } else {
                Object.assign(setupData[key], def);
            }
        }
        if (config[key]?.type === 'overwrite') {
            setupData[key] = def;
        }
    });
};

const setupFileStore: ContextFileStore = [];
const storeSetupFile = storeContextFile(setupFileStore, new RegExp('^./([^/]+)/setup.*.ts$'));
const setupFileContext = require.context('../config/', true, /setup.*\.ts$/);
setupFileContext.keys().forEach(storeSetupFile(setupFileContext));

export const buildClientSetupData = (config: ClientSetupConfig, setupData: any, packageSetupFiles: ContextFile[]) => {
    _.forEach(config, (element: ClientSetupConfigElement, key: string) => {
        if (setupData[key] === undefined) {
            setupData[key] = _.cloneDeep(element.init);
        }
    });
    _.forEach(getRelevantContextData(setupFileStore), (file: ContextFile) =>
        mergeClientSetupFile(config, setupData, file.data)
    );
    _.forEach(packageSetupFiles, (file: ContextFile) => mergeClientSetupFile(config, setupData, file.data));
    return setupData;
};

export const clientSetup: ClientSetup = {
    categories: [],
    mapSubcategoryToMaster: [],
};
